module.exports = __webpack_public_path__ + "static/img/bag-2.b6645d0b.svg";